import { createFileRoute } from '@tanstack/react-router'
import PlanImport from '../../../../../../containers/plan-import'
import { plansImportSearchSchema } from '../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/import/'
)({
  validateSearch: plansImportSearchSchema,
  component: RouteComponent
})

function RouteComponent() {
  return <PlanImport />
}
